
import { SizeOption } from './types';

// Kích thước áo Nam
export const MALE_SIZES: SizeOption[] = [
  { value: 'XS', label: 'XS', width: 44, length: 64 },
  { value: 'S', label: 'S', width: 46, length: 66 },
  { value: 'M', label: 'M', width: 48, length: 68 },
  { value: 'L', label: 'L', width: 50, length: 70 },
  { value: 'XL', label: 'XL', width: 52, length: 72 },
  { value: '2XL', label: '2XL', width: 54, length: 74 },
  { value: '3XL', label: '3XL', width: 56, length: 76 },
  { value: '4XL', label: '4XL', width: 58, length: 78 },
];

// Kích thước áo Nữ
export const FEMALE_SIZES: SizeOption[] = [
  { value: 'XS', label: 'XS', width: 38, length: 60 },
  { value: 'S', label: 'S', width: 40, length: 62 },
  { value: 'M', label: 'M', width: 42, length: 64 },
  { value: 'L', label: 'L', width: 44, length: 66 },
  { value: 'XL', label: 'XL', width: 46, length: 68 },
  { value: '2XL', label: '2XL', width: 48, length: 70 },
  { value: '3XL', label: '3XL', width: 50, length: 72 },
  { value: '4XL', label: '4XL', width: 52, length: 74 },
];
